(function ( $ ) {
    $.fn.confirmCallback = function(message, callback = function(){}, negativeCallback = function(){}, okayText = 'Ok', cancelText = 'Annuleren') {
        const elms = [];

        const resetFn = function(elms, doCallback = true) {
            $(elms).each((i, elm) => {
                const wrapper = elm.find('.confirm-callback-wrapper');
                wrapper.css({maxHeight: 0});
                setTimeout(() => {
                    wrapper.remove();
                }, 250);
            });
            if (doCallback) {
                callback();
            } else {
                negativeCallback();
            }
        };

        this.each(function() {
            const elm = $(this);
            elm.empty();
            elms.push(elm);

            const wrapper = $('<div class="confirm-callback-wrapper"></div>');
            wrapper.css({
                maxHeight: 0,
                overflow: 'hidden',
                transition: 'max-height 250ms ease',
                marginBottom: 15
            });

            const container = $('<div class="confirm-callback-container"></div>');

            const paragraph = $('<p></p>');
            paragraph.html(message);
            paragraph.addClass('callout warning');

            const buttonWrapper = $('<div></div>');

            const okay = $('<a></a>');
            okay.html(okayText);
            okay.css({fontSize: '14px', fontWeight: 'bold', marginRight: '25px'});
            okay.attr('href', '#');
            okay.click(function() {
                resetFn(elms, true);
                return false;
            });
            buttonWrapper.append(okay);

            const cancel = okay.clone();
            cancel.html(cancelText);
            cancel.click(function() {
                resetFn(elms, false);
                return false;
            });
            buttonWrapper.append(cancel);

            paragraph.append(buttonWrapper);


            container.append(paragraph);
            wrapper.html(container);
            elm.html(wrapper);
            wrapper.css({maxHeight: container.height()});
        });


        return this;
    };
}( jQuery ));
